import {Client} from "@/endpoints/rutsolve/gql/resolvers/client"
import {
    FinanceOverviewDocument,
    FinanceOverviewQueryVariables,
    FinanceResponse,
    FinanceInput
} from "@/endpoints/rutsolve/gql/generated/graphql"

export class Finance extends Client {
    constructor() {
        super()
    }

    public async overview(input: FinanceInput): Promise<FinanceResponse> {
        try {
            const variables: FinanceOverviewQueryVariables = {
                input: {
                    periodEnd: this.date(input.periodEnd),
                    periodStart: this.date(input.periodStart)
                },
            }
            const response = await this.client.request(FinanceOverviewDocument, variables)
            return response.finances
        } catch (error) {
            this.handleError(error)
        }
    }
}
